// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface DeleteOverrideRequest
 */
export interface DeleteOverrideRequest {
  /**
   * User performing the deletion.
   * @type {string}
   * @memberof DeleteOverrideRequest
   */
  deletedBy: string;
  /**
   * Reason for deleting the override.
   * @type {string}
   * @memberof DeleteOverrideRequest
   */
  deletionReason: string;
}

/**
 * Check if a given object implements the DeleteOverrideRequest interface.
 */
export function instanceOfDeleteOverrideRequest(
  value: object,
): value is DeleteOverrideRequest {
  if (!('deletedBy' in value) || value['deletedBy'] === undefined) return false;
  if (!('deletionReason' in value) || value['deletionReason'] === undefined)
    return false;
  return true;
}

export function DeleteOverrideRequestFromJSON(
  json: any,
): DeleteOverrideRequest {
  return DeleteOverrideRequestFromJSONTyped(json, false);
}

export function DeleteOverrideRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DeleteOverrideRequest {
  if (json == null) {
    return json;
  }
  return {
    deletedBy: json['deletedBy'],
    deletionReason: json['deletionReason'],
  };
}

export function DeleteOverrideRequestToJSON(json: any): DeleteOverrideRequest {
  return DeleteOverrideRequestToJSONTyped(json, false);
}

export function DeleteOverrideRequestToJSONTyped(
  value?: DeleteOverrideRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    deletedBy: value['deletedBy'],
    deletionReason: value['deletionReason'],
  };
}
